<template>
  <a :href="documentUrl" class="link--no-underline">
    <v-list-item>
      <v-list-item-icon>
        <v-icon>{{ documentIcon }}</v-icon>
      </v-list-item-icon>

      <v-list-item-content>
        <v-list-item-title>{{ attachment.title }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </a>
</template>

<script>
export default {
  name: "attachment",
  props: {
    attachment: Object,
  },
  computed: {
    documentUrl: function() {
      return this.attachment.link;
    },
    isLink: function() {
      return this.attachment.type === "link";
    },
    documentIcon: function() {
      if (this.isLink) {
        return "mdi-file-link";
      } else if (this.attachment.type === "application/pdf") {
        return "mdi-file-pdf-box";
      } else if (this.attachment.type === "pdf") {
        return "mdi-file-pdf-box";
      } else if (this.attachment.type === "image/jpeg") {
        return "mdi-file-image-outline";
      } else if (this.attachment.type === "jpeg") {
        return "mdi-file-image-outline";
      } else if (this.attachment.type === "png") {
        return "mdi-file-image-outline";
      } else if (this.attachment.type === "video/mp4") {
        return "mdi-file-video-outline";
      } else if (this.attachment.type === "mp4") {
        return "mdi-file-video-outline";
      } else {
        return "mdi-file-outline";
      }
    },
  },
  methods: {
    openDocument: function() {
      window.open(this.documentUrl, "_blank");
      // window.location.href = this.documentUrl;
    },
  },
};
</script>
<style scoped>
.link--no-underline {
  text-decoration: none;
}
</style>
